export default __webpack_public_path__ + "static/media/paypal2.f56dc17e.png";